// import external libraries
import { create } from 'zustand';

// import types
import type { DateNavigationStore } from './DateNavigation.types';

export const useDateNavigationStore = create<DateNavigationStore>((set) => ({
  period: null,
  setPeriod: (newPeriod) => set(() => ({ period: newPeriod }))
}));
